import axios from 'axios';

const Actions = {
    SET_USER({ commit }, user) {
        commit('SET_USER', user);
        commit('SET_AUTHENTICATED', true)
    },
    SET_AUTHENTICATED({commit}, val) {
        commit('SET_AUTHENTICATED', val)
    },
    SET_TOKEN({commit}, val) {
        commit('SET_TOKEN', val)
    },
    LOG_OUT({commit}) {
        commit('SET_AUTHENTICATED', false)
        commit('SET_USER', null);
        commit('GET_PROPERTY_OWNERS', null)
        commit('GET_PROPERTY_MANAGERS', null);
        commit('SET_TOKEN', null);
        commit('GET_PROPERTY_MANAGERS', null);
        commit('GET_TOTAL_USERS', null);
        commit('GET_TOTAL_MANAGERS', null);
    },
    //PROPERTY OWNERS
    GET_PROPERTY_OWNERS({commit, state}) {
        const token = state.token;
        const url = `${process.env.VUE_APP_SERVER_URL}/master/getAllOwners`;
        axios({
            method: 'get',
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            }
        }).then((res) => {
            const owners = res.data.owners
            commit('GET_PROPERTY_OWNERS', owners);
        }).catch((error)=>{
            console.log('error', error)
        })
    },
    //PROPERTY MANAGERS
    GET_PROPERTY_MANAGERS({commit, state}) {
        const token = state.token;
        const url = `${process.env.VUE_APP_SERVER_URL}/master/getAllSubAdmin`;
        axios({
            method: 'get',
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            }
        }).then((res) => {
            const managers = res.data.admins
            commit('GET_PROPERTY_MANAGERS', managers);
        }).catch((error)=>{
            console.log('error', error)
        })
    },
    GET_ALL_PROPERTY_RESIDENTS({commit, state}) {
        const token = state.token;
        const url = `${process.env.VUE_APP_SERVER_URL}/master/getAllUsers`;
        axios({
            method: 'get',
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            }
        }).then((res) => {
            const residents = res.data.users
            commit('GET_ALL_PROPERTY_RESIDENTS', residents);
        }).catch((error)=>{
            console.log('error', error)
        })
    },
    GET_TOTAL_USERS({commit, state}) {
        const token = state.token;
        const url = `${process.env.VUE_APP_SERVER_URL}/master/totalusers`;
        axios({
            method: 'get',
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            }
        }).then((res) => {
            const count = res.data.count
            commit('GET_TOTAL_USERS', count);
        }).catch((error)=>{
            console.log('error', error)
        })
    },
    GET_TOTAL_MANAGERS({commit, state}) {
        const token = state.token;
        const url = `${process.env.VUE_APP_SERVER_URL}/master/totalmanagers`;
        axios({
            method: 'get',
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            }
        }).then((res) => {
            const count = res.data.count
            commit('GET_TOTAL_MANAGERS', count);
        }).catch((error)=>{
            console.log('error', error)
        })
    },
};

export default Actions;